/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('faq-header')) {
  const FaqHeader = class extends HTMLElement {
    connectedCallback() {
      this.classNames = {
        questionContainerInactive: 'faq-search-item-inactive',
        sectionWithIndexStatus: 'section-faq-header--with-index'
      };

      this.searchInput = this.querySelector('.faq-search__input');
      if (this.searchInput) {
        this.searchInput.addEventListener('change', this.performSearch.bind(this));
        this.searchInput.addEventListener('keyup', this.performSearch.bind(this));
        this.searchInput.addEventListener('paste', this.performSearch.bind(this));
      }

      this.debouncedBuildIndex = debounce(this.buildIndex.bind(this), 50);
      document.addEventListener('theme:faq-header-update', this.debouncedBuildIndex);
      this.debouncedBuildIndex();

      if (this.querySelector('.faq-index')) {
        this.addEventListener('click', FaqHeader.handleIndexClick.bind(this));
        this.closest('.section-faq-header').classList.add(this.classNames.sectionWithIndexStatus);
        this.resizeIndex.call(this);
        this.debouncedResizeIndex = debounce(this.resizeIndex.bind(this), 250);
        window.addEventListener('resize', this.debouncedResizeIndex);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('theme:faq-header-update', this.debouncedBuildIndex);
      window.removeEventListener('resize', this.debouncedResizeIndex);
    }

    buildIndex() {
      const faqHeaderSection = this.closest('.section-faq-header');
      const indexContainer = this.querySelector('.faq-index__item-container');

      console.log('buildIndex');
      if (indexContainer) {
        indexContainer.querySelectorAll('.faq-index-item').forEach((el) => {
          el.parentNode.removeChild(el);
        });
      }

      this.linkedCollapsibleTabs = [];
      this.linkedQuestionContainers = [];
      this.linkedContent = [];

      let currentElement = faqHeaderSection;
      console.log(currentElement.nextElementSibling);
      console.log(currentElement.nextElementSibling.classList);
      // while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('faq-container')) {
      while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('shopify-section')) {
        console.log('while');
        currentElement = currentElement.nextElementSibling;

        // build list of searchable content
        this.linkedCollapsibleTabs.push(currentElement);
        currentElement.querySelectorAll('.collapsible-tabs__tab').forEach((el) => this.linkedQuestionContainers.push(el));
        currentElement.querySelectorAll('.collapsible-tabs__content').forEach((el) => this.linkedContent.push(el));
        // currentElement.querySelectorAll('.disclosure__title').forEach((el) => this.linkedQuestionContainers.push(el));
        // currentElement.querySelectorAll('.disclosure__content').forEach((el) => this.linkedContent.push(el));


        // build index UI
        if (indexContainer) {
          const currentElementHeading = currentElement.querySelector('.collapsible-tabs__heading');
          if (currentElementHeading) {
            const html = `
              <div class="faq-index-item">
                <a class="faq-index-item__link"></a>
              </div>`;
            const htmlFragment = document.createRange().createContextualFragment(html);
            const link = htmlFragment.querySelector('.faq-index-item__link');
            link.href = `#${currentElementHeading.id}`;
            link.innerHTML = currentElementHeading.innerHTML;
            indexContainer.appendChild(htmlFragment);
          }
        }
      }

      if (indexContainer) {
        this.resizeIndex.call(this);
      }
    }

    resizeIndex() {
      const stickyContainer = this.querySelector('.faq-index__sticky-container');
      const faqHeaderSection = this.closest('.section-faq-header');

      let currentElement = faqHeaderSection;
      while (currentElement.nextElementSibling && currentElement.nextElementSibling.classList.contains('faq-container')) {
        currentElement = currentElement.nextElementSibling;
      }

      const stickyContainerRect = stickyContainer.getBoundingClientRect();
      const currentElementRect = currentElement.getBoundingClientRect();

      stickyContainer.style.height = `${currentElementRect.bottom - stickyContainerRect.top}px`;
    }

    performSearch() {
      console.log('performSearch');
      // defer to avoid input lag
      setTimeout(() => {
        const splitValue = this.searchInput.value.split(' ');

        // sanitise terms
        const terms = [];
        splitValue.forEach((t) => {
          if (t.length > 0) {
            terms.push(t.toLowerCase());
          }
        });

        console.log(terms);
        console.log(this.linkedQuestionContainers);

        // search
        this.linkedQuestionContainers.forEach((el) => {
          if (terms.length) {
            let termFound = false;
            const matchContent = el.textContent.toLowerCase();
            terms.forEach((term) => {
              if (matchContent.indexOf(term) >= 0) {
                termFound = true;
              }
            });
            if (termFound) {
              // console.log(el);
              el.classList.remove(this.classNames.questionContainerInactive);
            } else {
              el.classList.add(this.classNames.questionContainerInactive);

              console.log(el);
              // console.log(FaqHeader.countSiblingsWithoutClass(el, this.classNames.questionContainerInactive));
              let headingEl = null;
              headingEl = FaqHeader.findPreviousSiblingWithClass(el, 'collapsible-tabs__heading');
              console.log(FaqHeader.countSiblingsWithoutClass(el, this.classNames.questionContainerInactive));
              console.log(headingEl);
              
              if (FaqHeader.countSiblingsWithoutClass(el, this.classNames.questionContainerInactive) === 0) {
                console.log('remove header');
                console.log(el);
    
                if (headingEl !== null) {
                  headingEl.classList.add(this.classNames.questionContainerInactive);
                }
              } else {
                // headingEl.classList.remove(this.classNames.questionContainerInactive);
              }
            }
          } else {
            el.classList.remove(this.classNames.questionContainerInactive);

              let headingEl = null;
              headingEl = FaqHeader.findPreviousSiblingWithClass(el, 'collapsible-tabs__heading');
              if (FaqHeader.countSiblingsWithoutClass(el, this.classNames.questionContainerInactive) === 0) {
            console.log('add back header');
                console.log(el);
                console.log(headingEl);
    
                if (headingEl !== null) {
                  headingEl.classList.remove(this.classNames.questionContainerInactive);
                }
              }
          }


        });

        


        // hide non-question content if doing a search
        // this.linkedContent.forEach((el) => {
        //   if (terms.length) {
        //     el.classList.add(this.classNames.questionContainerInactive);
        //   } else {
        //     el.classList.remove(this.classNames.questionContainerInactive);
        //   }
        // });
      }, 10);
    }

    static countSiblingsWithoutClass(element, className) {
      let count = 0;
      let parent = element.parentElement;
      if (!parent) return 0; // no parent means no siblings
    
      for (let sibling of parent.children) {
        if (sibling !== element && !sibling.classList.contains(className) && !sibling.classList.contains('collapsible-tabs__heading') && !sibling.classList.contains('collapsible-tabs__text')) {
          count++;
        }
        
      }
      return count;
    }
    
    static findPreviousHeading(element) {
      while (element) {
        element = element.previousElementSibling;
        if (element && element.classList.contains('collapsible-tabs__heading')) {
          return element;
        }
      }
      return null;
    }

    static findPreviousSiblingWithClass(element, className) {
      let sibling = element.previousElementSibling;
    
      while (sibling) {
        if (sibling.classList.contains(className)) {
          return sibling;
        }
        sibling = sibling.previousElementSibling;
      }
    
      return null; // No matching sibling found
    }
    
    static handleIndexClick(evt) {
      if (evt.target.classList.contains('faq-index-item__link')) {
        evt.preventDefault();
        const id = evt.target.href.split('#')[1];
        const scrollTarget = document.getElementById(id);
        let scrollTargetY = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 50;

        // sticky header offset
        const stickyHeight = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
        if (stickyHeight) {
          scrollTargetY -= parseInt(stickyHeight, 10);
        }

        window.scrollTo({
          top: scrollTargetY,
          behavior: 'smooth'
        });
      }
    }
  };

  window.customElements.define('faq-header', FaqHeader);
}
